import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const PDFDeclaration = () => (
	<Document>
		<Page size="A4" style={styles.page}>
			<View>
				<Text>Hello, this is a PDF!</Text>
			</View>
		</Page>
	</Document>
);

const styles = StyleSheet.create({
	page: { padding: 30 },
});

export default PDFDeclaration;

